import * as types from './mutation-types'
export default {
  [types.SET_USERS](state, users) {
    state.users = users
  },
}
